export interface ParseToken {
  document?: string
  email?: string
  iss: string
  name?: string
  stone_subject_id: `user:${string}`
  target?: string
  exp: number
  sub?: string
}

function base64UrlToBase64(base64Url: string): string {
  const padded = base64Url.padEnd(base64Url.length + ((4 - (base64Url.length % 4)) % 4), '=')
  return padded.replace(/-/g, '+').replace(/_/g, '/')
}

/**
 * Decodifica o payload de um JWT (base64url) e retorna o objeto tipado.
 * Retorna um objeto vazio se o token for inválido.
 */
export function parseToken({ token }: { token: string }): Partial<ParseToken> {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return {}
    return JSON.parse(atob(base64UrlToBase64(parts[1])))
  } catch {
    return {}
  }
}
